/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusAccountPageVo } from './BonusAccountPageVo';
import {
    BonusAccountPageVoFromJSON,
    BonusAccountPageVoFromJSONTyped,
    BonusAccountPageVoToJSON,
    BonusAccountPageVoToJSONTyped,
} from './BonusAccountPageVo';

/**
 * 
 * @export
 * @interface ResponseBonusAccountPageVo
 */
export interface ResponseBonusAccountPageVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBonusAccountPageVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBonusAccountPageVo
     */
    message?: string;
    /**
     * 
     * @type {BonusAccountPageVo}
     * @memberof ResponseBonusAccountPageVo
     */
    data?: BonusAccountPageVo;
}

/**
 * Check if a given object implements the ResponseBonusAccountPageVo interface.
 */
export function instanceOfResponseBonusAccountPageVo(value: object): value is ResponseBonusAccountPageVo {
    return true;
}

export function ResponseBonusAccountPageVoFromJSON(json: any): ResponseBonusAccountPageVo {
    return ResponseBonusAccountPageVoFromJSONTyped(json, false);
}

export function ResponseBonusAccountPageVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBonusAccountPageVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BonusAccountPageVoFromJSON(json['data']),
    };
}

export function ResponseBonusAccountPageVoToJSON(json: any): ResponseBonusAccountPageVo {
    return ResponseBonusAccountPageVoToJSONTyped(json, false);
}

export function ResponseBonusAccountPageVoToJSONTyped(value?: ResponseBonusAccountPageVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BonusAccountPageVoToJSON(value['data']),
    };
}

